import { createCrudPage } from './factories/crud-page.js';
import { renderDate } from '../core/grid/column-renderers.js';

const basePath = '/fb-savedforms';

/**
 * Form Builder — create/edit saved forms (`fb_savedforms`). The form definition is composed in
 * the `form_structure` form-builder field (fieldsets → fields → options); the codec serializes it
 * to the legacy wire array on save. The remaining columns are plain metadata (name, subject,
 * recipients, client, submit handler).
 *
 * @type {import('../contracts/page.js').PageMountFn}
 */
export default function mountFbSavedFormsPage(container, services) {
  return createCrudPage({
    title: 'Form Builder',
    basePath,
    columns: [
      { key: 'form_name', label: 'Name', sortable: true },
      { key: 'client', label: 'Client', sortable: true },
      { key: 'form_subject', label: 'Subject', sortable: true },
      { key: 'timestamp', label: 'Updated', sortable: true, renderHtml: true,
        render: (v) => renderDate(v, services.localeConfig) },
    ],
    fields: [
      { key: 'form_name', label: 'Form name', type: 'text', required: true },
      { key: 'form_subject', label: 'Email subject', type: 'text',
        fieldInfo: 'Subject line used when a submission is emailed.' },
      { key: 'mail', label: 'Recipient email', type: 'text' },
      { key: 'mail_cc', label: 'CC', type: 'text',
        fieldInfo: 'Semicolon-separated email addresses.' },
      { key: 'mail_bcc', label: 'BCC', type: 'text',
        fieldInfo: 'Semicolon-separated email addresses.' },
      { key: 'client', label: 'Client', type: 'text' },
      { key: 'submit_script', label: 'Form type', type: 'select',
        defaultValue: 'submit_form.php',
        options: [
          { value: '', label: 'Select type of form' },
          { value: 'submit_form.php', label: 'Contact form' },
          { value: 'test.php', label: 'Query form' },
        ] },
      { key: 'form_structure', label: 'Form fields', type: 'form-builder',
        fieldInfo: 'Build the form: add fieldsets, then fields. Drag or use the move buttons to reorder.' },
    ],
    defaultSort: { field: 'timestamp', dir: 'desc' },
  })(container, services);
}
